<template>
    <div class="row">
        <div class="col">
            <SubSection title="If you want to consider buying some guaranteed income" :show-help="false">
                <div class="container-fluid">
                    <div v-for="provider in providers" :key="provider.key" class="row pt-3">
                        <div class="d-block col-md-2 ps-0">
                            <img :src="provider.image" class="w-100" :alt="provider.name" />
                        </div>
                        <div class="d-block pt-4 col-md-8 pt-md-0 px-0 ps-md-4 text-start">
                            <p v-for="descriptionPart, i in provider.description" :key="i">{{ descriptionPart }}</p>
                        </div>
                        <div class="d-block col-md-2 pe-0">
                            <button class="btn btn-primary btn-sm float-end" @click="onFindAdviceClick(provider.key)">Get quotes</button>
                        </div>
                    </div>
                </div>
            </SubSection>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import SubSection from "../common/SubSection.vue";
import Monitoring from "@/guiide/ts/monitoring";
import { AnnuityProviderResponse } from "@/guiide/ts/response/annuityProviderResponse";
import { app } from "@/guiide/ts/app";

const store = useStore();
const providers = computed<Array<AnnuityProviderResponse>>(() => store.state.annuityProviders);

onMounted(() => {
    if (providers.value == null || providers.value.length == 0) {
        app.getAnnuityProviders();
    }
});

function onFindAdviceClick(providerKey: string) {
    const provider = providers.value.find(p => p.key == providerKey);
    const potsValue = store.state.retiree?.pensionPots.presentValue ?? 0;
    Monitoring.gaEvent('GInPrv' + provider.name.replace(' ', ''), potsValue);
    window.open(provider.url, "_blank");
}
</script>
